export const properties = {
    ID_BOTON: 'botonAyuda',
    ARIA_LABEL_BOTON : 'ayuda' 

}